<label *ngIf="to.header" class="form-control-label">{{ to.header }}</label>
<data-table
    [dataset]="field.props.entities || model['' + key] || []"
    (change)="change($event)"
    [paginator]="!to.disablePaginator"
    [scrollable]="to.scrollable"
    [showExport]="false"
    (onRowChanged)="onRowChanged($event)"
    [hideSelectAll]="to.hideSelectAll"
>
    <ng-container *ngFor="let column of to.columns">
        <column
            [value]="column.value"
            [type]="column.type"
            [filterable]="column.filterable"
            [filter]="getFilter(column)"
            [header]="column.header"
            [sortable]="column.sortable"
            [width]="column.width"
            [imageWidth]="column.imageWidth"
            [imageHeight]="column.imageHeight"
            [editable]="!to.disabled && column.editable"
            [visible]="column.visible"
            [min]="column.min"
            [max]="column.max"
            [step]="column.step"
            [required]="column.required"
            [tooltip]="column.tooltip"
            [totalInFooter]="column.totalInFooter"
            [frozen]="column.frozen"
            [filterType]="column.filterType"
            [options]="column.options"
            [numberPipe]="column.numberPipe"
            [stylingClass]="column.stylingClass"
            [readonlyInput]="column.readonlyInput"
        >
        </column>
    </ng-container>
</data-table>
<div *ngIf="to && to.note" class="col-12">
    <sub [innerHTML]="to.note"></sub>
</div>
<div class="clearfix"></div>
